import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserSmokingService } from 'src/app/services/user-smoking.service';

@Component({
  selector: 'app-weekly-report-chart-cigarettes',
  templateUrl: './weekly-report-chart-cigarettes.component.html',
  styleUrls: ['./weekly-report-chart-cigarettes.component.scss']
})
export class WeeklyReportChartCigarettesComponent {
  @Input() weeksData:any;

  public lineChartData: ChartConfiguration<'line'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Cigarettes',
        fill: true,
        tension: 0.5,
        borderColor: '#01E5BE',
        borderWidth:2,
        backgroundColor: '#01E5BE',
        pointBackgroundColor:'#01E5BE',
        pointBorderColor:'#ffffff',
      }
    ]
  };
  public lineChartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        type: 'linear',
        display: true,
        position: 'left',
        suggestedMax: 0,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "CIGARETTES",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public lineChartLegend = false;


  constructor(private userSmokingService:UserSmokingService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.lineChartData.datasets[0].data = [];
    this.lineChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.lineChartData.labels?.push(
        weekNo+1
      );
      var weekTotals = this.userSmokingService.geterateWeekTotals(weekData);
      this.lineChartData.datasets[0].data.push(weekTotals.totalCigarettes);
    });
  }


}
